import { TenFourLoader } from '@/components/feedback/TenFourLoader'
import s from './RouteFallback.module.css'

/**
 * Suspense fallback for route-level lazy chunks (PERF-13). Rendered (1) around
 * <Routes> for public pages + the admin shell, and (2) around each layout's
 * <Outlet/> so the sidebar/shell persists while a page chunk loads.
 */
export function RouteFallback() {
  return (
    <div className={s.wrap}>
      <TenFourLoader label="Loading workspace…" intro />
    </div>
  )
}
